import React, { PureComponent } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from './FormPreviewCard.module.less'

class FormPreviewCard extends PureComponent {
  render() {
    const { children, className, isPlain } = this.props

    const classNames = cx({
      [styles.card]: true,
      [className]: !!className,
    })

    if (isPlain) {
      return <div>{children}</div>
    }

    return <div className={classNames}>{children}</div>
  }
}

FormPreviewCard.propTypes = {
  className: PropTypes.string,
  isPlain: PropTypes.bool,
}

FormPreviewCard.defaultProps = {
  isPlain: false,
}

export default FormPreviewCard
